import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { RegisterPayload } from '../store/modules/registration/types';

class RegisterService {
  private route = apis.register;

  constructor(private api: ApiService) {}

  register = ({
    firstName,
    lastName,
    email,
    password,
    productCode,
    promoCode,
  }: RegisterPayload) => this.api.post<[]>(
    this.route.new,
    {
      product_code: productCode,
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      promotion_code: promoCode,
      ...(process.env.REACT_APP_BUILD_ENV === 'development' && { debug_allow_existing_user: true }),
    },
  ).then(() => undefined);

  resend = (email: string) => this.api.put<[]>(
    this.route.resend,
    {
      email,
    },
  );
}

export default new RegisterService(apiService);
